module.exports = __webpack_public_path__ + "media/images/slide-6-ed68146b30a5cf11ef0e91902f5c49da.jpg";